import { useTranslation } from 'react-i18next'
import Checkbox from './ui/Checkbox'
import { useAppContext } from '../contexts/AppContext'

const AcceptPolicy = ({ isPolicyAccepted, setIsPolicyAccepted }) => {
  const { t } = useTranslation()
  const { privacyUrl } = useAppContext()

  const handleCheckboxChange = e => {
    setIsPolicyAccepted(e.target.checked)
  }

  return (
    <div className="flex justify-center text-center px-4 text-sm dark:text-zinc-400">
      <Checkbox
        id="wp-policy-acceptance"
        onChange={handleCheckboxChange}
        checked={isPolicyAccepted}
        text={
          <div className="max-sm:flex max-sm:flex-col max-sm:items-start">
            <div className={'whitespace-pre-line max-sm:text-left'}>{t('policy.leading', 'I have read the')}</div>
            <a className="underline text-[#bbb] px-1 max-sm:p-0 " href={privacyUrl} target="_blank">
              {t('policy.link', 'terms and privacy policy')}
            </a>
          </div>
        }
      />
    </div>
  )
}

export default AcceptPolicy
